export default {
  URL: process.env.VUE_APP_API_URL,
  ENV: process.env.VUE_APP_ENV,
  BASIC_AUTH: process.env.VUE_APP_BASIC_AUTH_TOKEN,
  SUBDOMAIN: process.env.VUE_APP_SUBDOMAIN,
  CHARGEBEE_SOURCE: process.env.VUE_APP_CHARGEBEE_SOURCE,
  CHARGEBEE_MONTHLY: process.env.VUE_APP_CHARGEBEE_MONTHLY,
  CHARGEBEE_YEARLY: process.env.VUE_APP_CHARGEBEE_YEARLY,
  // Empty turns the reCAPTCHA widget off (localhost isn't an allowed reCAPTCHA domain).
  RECAPTCHA_SITE_KEY: process.env.VUE_APP_RECAPTCHA_SITE_KEY || '',
  // Empty turns product analytics (PostHog) off.
  POSTHOG_KEY: process.env.VUE_APP_POSTHOG_KEY || '',
  // Stripe publishable key (public). Empty turns card payments off: no Pay buttons or card toggle.
  STRIPE_PUBLISHABLE_KEY: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || '',
  POSTHOG_HOST: process.env.VUE_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  // Where files in public/ are served from (Vue CLI's publicPath).
  PUBLIC_PATH: process.env.BASE_URL || '/',
};
